import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { useUserState } from '../../../../shared/hooks/accountHook';
import notVerifiedIcon from '../../assets/icons/icon_not-verified.svg';
import peopleIcon from '../../assets/icons/icon_people.svg';
import verifiedIcon from '../../assets/icons/icon_verified.svg';
import { BlueRoundedButtonWithIcon } from '../../common/components/BlueRoundedButton';
import { ColoredIcon } from '../../common/components/Icon';
import { WindowSize, WindowSizeContext } from '../../hooks/windowSizeHook';

const ProfileRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-self: center stretch;
  justify-content: space-between;
  width: 956px;
  max-width: 100%;
  margin-top: 34px;
`;

const ProfileWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ProfileIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 67px;
  height: 67px;
  border-radius: 67px;
  background: var(--HPACS_BG_grey, #f5f5f5);
  margin-right: 25px;

  ${p =>
    p.theme.isMobile &&
    `
    background: white;
    `}
`;

const ProfileNameWrapper = styled.div<{
  $imageUrl: string;
}>`
  display: flex;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;

  &::after {
    content: '';
    background-image: url(${p => p.$imageUrl});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    width: 15px;
    height: 22px;
    margin-left: 9px;
  }
`;

export interface ProfileProps {
  onClickEditPassword: () => void;
}
export const Profile = (props: ProfileProps) => {
  const { onClickEditPassword } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.myPage',
  });
  const [user] = useUserState();

  const isMobile = useContext(WindowSizeContext) === WindowSize.MOBILE;

  return (
    <ProfileRow>
      <ProfileWrapper>
        <ProfileIconWrapper>
          <ColoredIcon
            imageUrl={peopleIcon}
            width="24px"
            height="24px"
            imageWidth="18px"
            color={'var(--HScan_Light_Blue, #2e5be0)'}
          />
        </ProfileIconWrapper>
        <ProfileNameWrapper
          $imageUrl={user?.identified ? verifiedIcon : notVerifiedIcon}>
          {user?.name}
        </ProfileNameWrapper>
      </ProfileWrapper>
      {!isMobile && (
        <BlueRoundedButtonWithIcon
          maxWidth="181px"
          onClick={onClickEditPassword}>
          {t('slots.password.title')}
        </BlueRoundedButtonWithIcon>
      )}
    </ProfileRow>
  );
};
